import { render, staticRenderFns } from "./TradeRequestDirectItems.vue?vue&type=template&id=03bae57c"
import script from "./TradeRequestDirectItems.vue?vue&type=script&lang=js"
export * from "./TradeRequestDirectItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports